export default __webpack_public_path__ + "img/lang.1282d70.svg";